import React, { useEffect, useState } from "react";
import { AxiosResponse, AxiosError } from "axios";
import { network, Results } from "../../interface/Network";
import { NetworkAxiosInstance } from "../../Network/NetworkAxiosInstance";
import "react-toastify/dist/ReactToastify.css";
import Joi from "joi";
import { ColumnDef } from "@tanstack/react-table";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import DataTable2 from "shared/DataTable2";
import { Toaster } from "../../components/ui/toaster";
import { useToast } from "../../hooks/use-toast";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/Label";
const Network: React.FC = () => {
  const [items, setItems] = useState<network>({ result: [] });
  const [networkName, setNetworkName] = useState<string>("");
  const [relatedProviders, setRelatedProviders] = useState<number[]>([]);
  const [relatedProvidersError, setRelatedProvidersError] = useState<string>("");
  const [editIndex, setEditIndex] = useState<null | number>(null);
  const [networkError, setNetworkError] = useState<string>("");
  const [NetworkisValid, setNetworkIsValid] = useState<boolean>(true);
  const [RelatedProvidersisValid, setRelatedProvidersIsValid] = useState<boolean>(true);
  const token = localStorage.getItem("token") || "";
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [filterSearch, setFilterSearch] = useState<string>("");

  useEffect(() => {
    fetchItems();
  }, []);

  // Initialize toast
  const { toast } = useToast();

  // Dialog control handlers
  const handleAddClick = () => {
    setEditIndex(null);
    clear();
    setIsDialogOpen(true);
  };

  const handleEditClick = (item: Results) => {
    handleEdit(item);
    setIsDialogOpen(true);
  };


  const relationproviderschema = Joi.string()
    .allow('')
    .regex(/^[0-9,]*$/)
    .messages({
      "string.pattern.base": "Please enter only numbers ",
    });
  const clear = () => {
    setNetworkName("");
    setRelatedProviders([]);
  }

  const Networkvalidate = (): boolean => {
    if (!networkName.trim()) {
      setNetworkError("Network Name is required");
      setNetworkIsValid(false);

      return false;
    }
    setNetworkError("");
    setNetworkIsValid(true);

    return true;
  };
  const validateNetworkName = (name: string) => {
    if (name.trim()) {
      setNetworkError("");
      setNetworkIsValid(true);
    } else {
      setNetworkError("Network Name is required.");
      setNetworkIsValid(false);
    }
  };

  const RelatedProvidersvalidate = (): boolean => {
    if (relatedProviders.length === 0) {
      setRelatedProvidersError("Related Providers is required");
      setRelatedProvidersIsValid(false);

      return false;
    }
    setRelatedProvidersError("");
    setRelatedProvidersIsValid(true);

    return true;
  };

  const handleNetworkChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setNetworkName(value);
    // Check as you type
    validateNetworkName(value);
  };
  const handlrelationproviderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    const { error } = relationproviderschema.validate(value);

    if (error) {
      setRelatedProvidersError(error.message);
      setRelatedProvidersIsValid(false);

    } else {
      setRelatedProvidersError("");
      setRelatedProvidersIsValid(true);
      setRelatedProviders(value ? value.split(",").map(Number) : []);
    }
  };

  const fetchItems = async (): Promise<void> => {
    try {
      const response: AxiosResponse<{ success: boolean; result: Results[] }> =
        await NetworkAxiosInstance.get("getnetwork");
      setItems({ result: [...response.data.result].sort((a: any, b: any) => b.id - a.id) });

      console.log(response.data.result)
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };

  const addItem = async (): Promise<void> => {
    const isFormValid = Networkvalidate();
    const isForm2Valid = RelatedProvidersvalidate();

    if (!isFormValid || !isForm2Valid) {
      return;
    }
    try {
      const newNetwork = {
        network_name: networkName,
        related_providers: relatedProviders,
        token,
      };
      const response = await NetworkAxiosInstance.post("addnetwork", newNetwork);

      if (response.data.success) {
        fetchItems();
        clear();
        setRelatedProvidersIsValid(true);
        setNetworkIsValid(true);
        toast({
          title: "success",
          description: "New network Added Successfully.",
        });
        setIsDialogOpen(false);
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        console.error("Error adding item:", error);
        setNetworkIsValid(false);
        toast({
          title: "error",
          description: `${error.response.data.error}`,
        });
      } else {
        // If there is another error unrelated to the response such as a connection interruption
        toast({
          title: "error",
          description: 'An unexpected error occurred.',
        });
      }
    }
  }

  const removeItem = async (id: string | number): Promise<void> => {
    const confirmed = window.confirm("Are you sure you want to delete this Insurance Plan?");
    if (!confirmed) return; // Exit if user cancels
    try {
      const response = await NetworkAxiosInstance.delete(`deletenetwork/${id}`, {
        data: { token },
      });

      if (response.data.success) {
        fetchItems();
        toast({
          title: "success",
          description: "Network Deleted Successfully.",
        });
      } else {

        toast({
          title: "error",
          description: `${response.data.error}`,
        });
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        const errorMessage = error.response.data.error || 'An unexpected error occurred.';

        toast({
          title: "error",
          description: errorMessage,
        });
      } else {
        toast({
          title: "error",
          description: 'An unexpected error occurred.',
        });
      }
    }
  };



  const updateItem = async (id: string | number): Promise<void> => {
    const isFormValid = Networkvalidate();
    const isForm2Valid = RelatedProvidersvalidate();

    if (!isFormValid || !isForm2Valid) {
      return;
    }
    try {
      const updatedItem = {
        network_name: networkName,
        related_providers: relatedProviders,
        token,
        id: id,

      };

      const response = await NetworkAxiosInstance.put("updatenetwork", updatedItem);
      if (response.data.success) {
        fetchItems();
        clear();
        setRelatedProvidersIsValid(true);
        setNetworkIsValid(true);
        toast({
          title: "success",
          description: "New network updated successfully.",
        });
        setIsDialogOpen(false);
      }
    } catch (error: AxiosError | any) {
      if (error.response) {
        console.error("Error adding item:", error);
        toast({
          title: "error",
          description: `${error.response.data.error}`,
        });

      } else {
        // If there is another error unrelated to the response such as a connection interruption
        toast({
          title: "error",
          description: 'An unexpected error occurred.',
        });
      }
    }
  };
  const handleEdit = (item: Results) => {
    setNetworkName(item.network_name);
    setRelatedProviders(item.related_providers);
    setEditIndex(item.id);
  }

  const columns: ColumnDef<Results>[] = [
    {
      accessorKey: "id",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          ID
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
              ? " ↓"
              : ""}
        </Button>
      ),
    },
    {
      accessorKey: "network_name",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Networ Name
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
              ? " ↓"
              : ""}
        </Button>
      ),
    },
    {
      accessorKey: "related_providers",
      header: ({ column }) => (
        <Button
          variant="ghost"
          onClick={() => column.toggleSorting(column.getIsSorted() === "asc")}
        >
          Related Providers
          {column.getIsSorted() === "asc"
            ? " ↑"
            : column.getIsSorted() === "desc"
              ? " ↓"
              : ""}
        </Button>
      ),
      cell: ({ row }) => {
        const rawProviders = row.getValue("related_providers");
        const providers = Array.isArray(rawProviders)
          ? rawProviders.map(String)
          : rawProviders != null
            ? [String(rawProviders)]
            : [];

        if (providers.length === 0) {
          return <div className="w-full text-center text-gray-400">-</div>;
        }

        const searchTerm = filterSearch.toLowerCase().trim();
        const hasSearch = searchTerm.length >= 2;
        const matchingProviders = hasSearch
          ? providers.filter((provider) =>
              provider.toLowerCase().includes(searchTerm),
            )
          : [];

        const hasMatches = hasSearch && matchingProviders.length > 0;
        const displaySource = hasMatches ? matchingProviders : providers;
        const displayedProviders = displaySource.slice(0, 3);
        const remainingCount = Math.max(
          0,
          displaySource.length - displayedProviders.length,
        );

        return (
          <div className="w-full px-2 py-1.5">
            <div className="flex flex-wrap justify-center gap-1.5">
              {displayedProviders.map((provider, index) => {
                const isMatching =
                  hasSearch &&
                  provider.toLowerCase().includes(searchTerm);

                return (
                  <span
                    key={`${provider}-${index}`}
                    className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-semibold ${
                      isMatching
                        ? "bg-yellow-200 text-yellow-900 border-yellow-400"
                        : "bg-blue-100 text-blue-800 border-blue-200"
                    }`}
                  >
                    {provider}
                  </span>
                );
              })}

              {remainingCount > 0 && (
                <span
                  className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-semibold ${
                    hasMatches
                      ? "bg-yellow-100 text-yellow-800 border-yellow-300"
                      : "bg-slate-100 text-slate-700 border-slate-300"
                  }`}
                >
                  +{remainingCount} more
                </span>
              )}
            </div>

            <div className="mt-1 text-center text-[10px] text-gray-400">
              {hasMatches
                ? `${matchingProviders.length}/${providers.length}`
                : `${providers.length} total`}
            </div>
          </div>
        );
      },
    },

  ];


  return (
    <div className="container" style={{ margin: "30px" }}>
      <h5>
        Network Screen{" "}
        <span>
          {" "}
          <i className="fa-solid fa-briefcase"></i>{" "}
        </span>{" "}
      </h5>


      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>
              {editIndex === null
                ? "Add Network Group"
                : "Edit Network Group"}
            </DialogTitle>
            </DialogHeader>
          <div className="flex flex-col space-y-4">
            <div className="grid gap-2">
              <Label htmlFor="Network">Network</Label>
              <Input
                id="Network"

                value={networkName}
                // Check as you type
                onChange={handleNetworkChange}

                placeholder="Network is required . "
              />
            </div>
            <div className="grid gap-2">
              <Label htmlFor="Related Providers">Related Providers:</Label>
              <Input
                id="Related Providers"
                value={relatedProviders.join(",")}

                onChange={handlrelationproviderChange}

                placeholder="Related Providers is required enter only numbers. "
              />
            </div>

          </div>

          <DialogFooter className="gap-2">
            <Button
              onClick={() => {
                if (editIndex === null) {
                  addItem();
                } else {
                  updateItem(editIndex);
                }
              }}
              className="bg-blue-600 hover:bg-blue-700"
            >
              {editIndex === null ? "Add Relation " : "Update Relation "}
            </Button>
            <Button
              variant="outline"

              onClick={(e) => {
                setEditIndex(null);
                clear();
                setIsDialogOpen(false);
              }}
            >
              Cancel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>

      <Toaster />

      <DataTable2
        columns={columns}
        data={items.result}
        searchColumns={["network_name", "related_providers"]}
        searchValue={filterSearch}
        onSearchChange={setFilterSearch}
        searchPlaceholder="Search..."
        searchHelpText="Network Name or Related Provider."
        addButtonLabel="Add New Network"
        showAddButton={true}
        onEdit={handleEdit}
        onDelete={removeItem}
        onAdd={handleAddClick}
        onEditClick={handleEditClick}
      />

    </div>
  );
};

export default Network;